import { genericPlayerParser } from '../commonInbounds/utils/genericPlayerInboundUtils';
import { createArrayWithBracesParser } from '../inboundParsers';
export const UPDATE_MTT_STAGING_PLAYERS_PAYLOAD_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [{ name: 'players', parser: createArrayWithBracesParser(genericPlayerParser) }]
};
